export default __webpack_public_path__ + "static/media/post-fake.5f3ab422.svg";